import Fuse from 'fuse.js';

export const state = {
    hasActiveDropdown: false,
    fuses: new WeakMap(),
};

const initializedContainers = new WeakSet();

/**
 * @param {HTMLElement} selectContainer
 */
export const initializeSelectContainer = selectContainer => {
    if (initializedContainers.has(selectContainer)) {
        return;
    }

    initializedContainers.add(selectContainer);

    if (selectContainer.dataset.searchable === 'true') {
        const list = [];

        if (selectContainer.classList.contains('links')) {
            selectContainer.querySelectorAll('.options li').forEach(listItem => {
                const text = (listItem.querySelector('a')?.textContent ?? listItem.textContent).trim();
                list.push({text, value: text});
            });
        } else {
            selectContainer.querySelectorAll('option').forEach(option => {
                if (option.value === '') {
                    return;
                }

                list.push({text: option.textContent, value: option.value});
            });
        }

        state.fuses.set(selectContainer, new Fuse(list, {
            keys: ['text', 'value'],
            threshold: 0.2,
            findAllMatches: true,
            ignoreLocation: true,
            ignoreDiacritics: true,
        }));

        selectContainer.querySelector('input').addEventListener('change', (event) => event.stopPropagation());

        selectContainer.querySelector('input').addEventListener('input', (event) => {
            const focusedOption = selectContainer.querySelector('.focus');

            if (focusedOption) {
                focusedOption.classList.remove('focus');
            }

            if (event.target.value === '') {
                selectContainer.querySelectorAll('li').forEach(listItem => listItem.classList.remove('hidden'));
                selectContainer.querySelector('.options li')?.classList.add('focus');

                return;
            }

            // sort and shift for poor man's O(n)'s traversal
            const results = state.fuses.get(selectContainer)
                .search(event.target.value)
                .sort((left, right) => left.refIndex > right.refIndex ? 1 : -1)
            ;

            let firstVisible = null;

            selectContainer.querySelectorAll('li').forEach((listItem, index) => {
                if (results[0] && results[0].refIndex === index) {
                    listItem.classList.remove('hidden');
                    results.shift();

                    if (!firstVisible) {
                        firstVisible = listItem;
                    }

                    return;
                }

                listItem.classList.add('hidden');
            });

            firstVisible?.classList.add('focus');
        });
    }

    selectContainer.dataset.isDrawer = selectContainer.querySelector('.dropdown.drawer') === null ? 'false' : 'true';
};
